import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';

import buttonInnerStyle from 'src/components/View/Header/buttonInner.style';

function ButtonInner({
  classes,
  className,
  children,
}) {
  return (
    <div
      className={`${classes.root} inner ${className}`}
    >
      {children}
    </div>
  );
}

ButtonInner.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
};

ButtonInner.defaultProps = {
  className: '',
};

export default withStyles(ButtonInner, buttonInnerStyle, { withTheme: true });
